import { initializeApp } from 'firebase/app';

const firebase = initializeApp({
    apiKey: "AIzaSyBwWn9sy5E11TkEhB6eRaOY4QHeU-oT1Po",
    authDomain: "pizarra-resultados.firebaseapp.com",
    databaseURL: "https://pizarra-resultados-default-rtdb.firebaseio.com",
    projectId: "pizarra-resultados",
    storageBucket: "pizarra-resultados.firebasestorage.app",
    messagingSenderId: "334913194829",
    appId: "1:334913194829:web:8e449f30571524e43f0504",
    measurementId: "G-ZXWQQWWK2Q"
});

export default firebase;